import { BaseFileType } from '@commenda/types/src/file/types';
import { DirectorBase } from '@commenda/types/src/incorporation/types';
import { Country, LegacyDocumentType } from '@prisma/client';

export const getIdentityProof = (
  director: DirectorBase,
  corporationId: number
): BaseFileType => {
  const identityProofDocumentTypes: LegacyDocumentType[] = [
    LegacyDocumentType.Passport,
    LegacyDocumentType.DrivingLicense,
    LegacyDocumentType.VoterId,
  ];
  const corporationHasDirector = director?.corporationHasDirector?.find(
    (each) => each.corporationId === corporationId
  );

  let identityProofFile;
  if (director?.personalDetails?.nationality === Country.IN) {
    if (
      corporationHasDirector?.incorporationInfo?.identityProofTypeUsedByDirector
    ) {
      identityProofFile = director?.directorFiles
        ?.sort((a, b) => b.id - a.id)
        .find(
          (eachFile) =>
            eachFile.documentType ===
            corporationHasDirector.incorporationInfo
              .identityProofTypeUsedByDirector
        );
    } else {
      identityProofFile = director?.directorFiles
        ?.sort((a, b) => b.id - a.id)
        .find((eachFile) =>
          identityProofDocumentTypes.includes(eachFile.documentType)
        );
    }
  } else {
    identityProofFile = director?.directorFiles
      ?.sort((a, b) => b.id - a.id)
      .find(
        (eachFile) => eachFile.documentType === LegacyDocumentType.Passport
      );
  }
  return identityProofFile;
};
